import React from 'react';
import { Modal } from 'react-bootstrap';

import InputField from '@components/InputField';
import SelectOptions from '@components/SelectOptions';

import { validateNumber } from '@utils/Util';

const AddNewTaskModal = ({
	onModalCancel,
	showModal,
	taskFormInputData,
	stageTaskList,
	handleAddTaskFormChange,
	errors,
	loading,
	onSubmit
}) => {
	const deliverableOptions =
		stageTaskList?.map((stage) => ({
			value: stage.subTask[0].deliverableId,
			label: stage.subTask[0].deliverableName
		})) || [];

	const stepNameOptions =
		stageTaskList?.flatMap((stage) =>
			stage.subTask.map((task) => ({
				value: task.id,
				label: task.stepDescription
			}))
		) || [];

	return (
		<Modal show={showModal} onHide={() => onModalCancel()} centered>
			<div className="common-popup shadow-24dp">
				<Modal.Header closeButton>
					<h3 className="semibold-16 mb-0">Add new task</h3>
				</Modal.Header>
				<Modal.Body>
					<div className="common-popup-body">
						<div className="container px-0">
							<div className="row">
								<div className="col-md-12">
									<InputField
										value={taskFormInputData.taskName}
										onChangeHandler={handleAddTaskFormChange}
										name="taskName"
										label="taskName"
										id="t-name"
										labelTitle="Task name*"
										errors={errors?.taskName}
									/>
								</div>
								<div className="col-md-12">
									<SelectOptions
										value={taskFormInputData.deliverableName}
										onChangeHandler={handleAddTaskFormChange}
										name="deliverableName"
										id="deliverableName"
										labelTitle="Deliverable*"
										options={deliverableOptions}
										errors={errors?.deliverableName}
									/>
								</div>
								<div className="col-md-6 pl-2">
									<SelectOptions
										value={taskFormInputData.stepName}
										onChangeHandler={handleAddTaskFormChange}
										name="stepName"
										id="stepName"
										labelTitle="Dependent task name*"
										options={stepNameOptions}
										errors={errors?.stepName}
									/>
								</div>
								<div className="col-md-6 pr-2">
									<InputField
										value={taskFormInputData.duration}
										onChangeHandler={handleAddTaskFormChange}
										type="number"
										id="s-duration"
										name="duration"
										labelTitle="Standard duration*"
										errors={errors?.duration}
										min={0}
										onKeyPress={(e) => validateNumber(e)}
									/>
								</div>

								<div className="col-md-6 pr-2">
									<div className="form-group">
										<label htmlFor="sDate">Start date</label>
										{taskFormInputData.startDate}
									</div>
								</div>

								<div className="col-md-6 pl-2">
									<div className="form-group">
										<label htmlFor="eDate">End date</label>
										{taskFormInputData.endDate}
									</div>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={() => onModalCancel()}>
							Cancel
						</button>
						<button disabled={loading} className="button size32 ml-2" onClick={onSubmit}>
							Submit
						</button>
					</div>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default AddNewTaskModal;
